@use "styles" as *;
@use "sass:map";

$block: me-section;

@mixin expand-slider {
  .me-slider {
    margin-left: -$main-padding;
    margin-right: -$main-padding;
  }
}

.#{$block} {
  display: block;

  @include remove-first-and-last-child-margins;

  @each $theme, $theme-options in $section-themes {
    &--#{$theme} {
      background: map.get($theme-options, background);
    }
  }

  &[theme] {
    padding: space(5) $main-padding;
    overflow: hidden;

    @include expand-slider;
  }

  .me-box {
    padding: 0 space(1);
  }

  &--full-width-mobile {
    @include media-breakpoint-down(detail) {
      @include expand-slider;

      &[theme] {
        margin: 0 (-$main-padding);
      }

      .me-box {
        padding: 0;
      }
    }
  }

  &--full-width-all {
    @include media-breakpoint-down(container) {
      @include expand-slider;

      &[theme] {
        margin: 0 (-$main-padding);
      }

      .me-box {
        padding: 0;
      }
    }
  }

  .me-slider--collection, &[theme] .me-slider--collection {
    margin-left: calc(($main-padding + $me-section-collection-slide-margin-horizontal + $me-teaser-card-padding-horizontal) / -2);
    margin-right: calc(($main-padding + $me-section-collection-slide-margin-horizontal + $me-teaser-card-padding-horizontal) / -2);

    .swiper-slide:first-child {
      margin-left: space(4);
    }
  }
}

.me-detail-layout .#{$block} {
  &--full-width-all {
    @include media-breakpoint-up(detail) {
      &[theme] {
        margin: 0 calc((100vw - $scrollbar-width - $detail-max-width) / -2);
      }

      &:not([theme]) {
        margin: 0 calc((100vw - $scrollbar-width - $detail-max-width) / -2 + $main-padding);
      }
    }

    @include media-breakpoint-up(container) {
      &[theme] {
        margin: 0 calc(($container-max-width - $detail-max-width) / -2);
      }

      &:not([theme]) {
        margin: 0 calc(($container-max-width - $detail-max-width) / -2 + $main-padding);
      }
    }
  }
}
